export default "__VITE_ASSET__UaUc1Nf9__"